<app-top-navbar [title]="'profiles.verification.title' | translate">
  <a class="top-bar-link"
     [routerLink]="['../../']">
    <i class="icon icon-chevron-left"></i>
  </a>
</app-top-navbar>
<div class="wrapper page-verification">
  @if (displayLogout) {
    <div class="content">
      <app-alert alertType="error"
                 [withIcon]="true">
        {{ 'profiles.verification.session_mismatch' | translate }}
      </app-alert>
      <button class="btn btn-block btn-raised btn-primary"
              (click)="signOut()">{{ 'member.member-page.sign_out' | translate }}
      </button>
    </div>
  }
  @if (displayStatus) {
    <div class="content">
      @if (verificationStatus.email) {
        <div class="row">
          <div class="col-xs-12">
            <div [ngClass]="{'is-focused': $any(email).isFocused}"
                 class="form-group label-static is-empty email form-control-email">
              <label class="control-label">
                <span>{{ 'attributes.email' | translate }}</span>
              </label>
              <input class="form-control field-email"
                     readonly
                     type="email"
                     [formControl]="$any(form.get('email'))"
                     #email appFocusable (onFocusChange)="$any(email).isFocused = $event">
              @if (!isEmailVerified && !isVerificationEmailSent) {
                <button (click)="verifyEmail()"
                        class="btn btn-primary btn-block btn-raised">{{ 'profiles.verification.send_verification_email' | translate }}
                </button>
                @if (isVerificationEmailError) {
                  <app-alert alertType="error"
                             [withIcon]="true">
                    {{ 'profiles.verification.email_sent_error' | translate }}
                  </app-alert>
                }
              } @else {
                @if (isEmailVerified) {
                  <app-alert alertType="success"
                             [withIcon]="true">
                    {{ 'profiles.verification.email_verified' | translate }}
                  </app-alert>
                }
                @if (isVerificationEmailSent) {
                  <app-alert alertType="success"
                             [withIcon]="true">
                    {{ 'profiles.verification.email_sent' | translate }}
                  </app-alert>
                }
              }
            </div>
          </div>
        </div>
      }
      @if (verificationStatus.msisdn) {
        <div class="row">
          <div class="col-xs-12">
            <app-msisdn-input [passedFormControl]="$any(form.get('msisdn'))"
                              [readonly]="true"/>
            @if (!isPhoneVerified && !isVerificationSMSSent) {
              <button (click)="verifyMsisdn()"
                      class="btn btn-primary btn-block btn-raised">{{ 'profiles.verification.send_verification_sms' | translate }}
              </button>
              @if (isVerificationSMSError) {
                <app-alert alertType="error"
                           [withIcon]="true">
                  {{ 'profiles.verification.sms_sent_error' | translate }}
                </app-alert>
              }
            } @else {
              @if (isPhoneVerified) {
                <app-alert alertType="success"
                           [withIcon]="true">
                  {{ 'profiles.verification.msisdn_verified' | translate }}
                </app-alert>
              }
              @if (isVerificationSMSSent) {
                <app-alert alertType="success"
                           [withIcon]="true">
                  {{ 'profiles.verification.sms_sent' | translate }}
                </app-alert>
              }
            }
          </div>
        </div>
      }
    </div>
  }
  <app-loyalty-club-footer/>
</div>
